<template>
    <div style="background-color: white">
      <iframe ref="iframe" :src="url" width="100%" height="600px"></iframe>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        url: this.$route.query.url
      }
    },
    mounted( ) {
      this.url = this.$route.query.url;
      window.addEventListener('message', this.handleMessage);
    },
    beforeDestroy() {
      window.removeEventListener('message', this.handleMessage);
    },
    methods: {
      handleMessage(event) {
        if (event.data.type === 'resize') {
          this.$refs.iframe.style.height = `${event.data.height}px`;
        }
      }
    }
  }
  </script>
  
  <style>
  </style>